import React, { useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { accountDetail, bankListRequest, createAccount, payout, withdrawlRequest } from '../../Services/DashboardServices';
import toast from 'react-hot-toast';
import Loader from '../Main/Loader';
import { useSelector } from 'react-redux';

const RequestWithdrawal = ({ handleGetUser, wallet_balance, min_amount }) => {
    const user = useSelector((state) => state.auth.data);
    const [amount, setAmount] = useState("");
    const [bankName, setBankName] = useState(""); // used for payment method
    const [accountNumber, setAccountNumber] = useState("");
    const [accountTitle, setAccountTitle] = useState("");
    const [isLoading, setIsLoading] = useState("");
    const [contact, setContact] = useState("");
    const [bankList, setBankList] = useState([]);


    const handleAmount = (e) => setAmount(e.target.value);
    const handleBankName = (e) => setBankName(e.target.value);
    const handleAccNumber = (e) => setAccountNumber(e.target.value);
    const handleAccTitle = (e) => setAccountTitle(e.target.value);
    const handleContact = (e) => setContact(e.target.value);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!accountTitle) {
            return toast?.error("Please enter Account Title");
        }


        if (!amount) {
            return toast?.error("Please enter Amount");
        }


        if (!accountNumber) {
            return toast?.error("Please enter account number");
        }


        if (!bankName) {
            return toast?.error("Please enter bank name");
        }
        if (!contact) {
            return toast?.error("Please enter contact number");
        }

        const body = {
            // user_id: user?.id,
            bank_name: bankName,
            account_number: accountNumber,
            account_title: accountTitle,
            amount: amount,
            contact: contact
        };
        if (amount < min_amount) {
            toast?.error(`Please Withdraw minimum ${min_amount}`)
            setIsLoading(false);
            return;
        }
        if (Number(amount) > Number(wallet_balance)) {
            toast?.error("Amount exceeded your balance");
            setIsLoading(false);
            return;
        } else {
            setIsLoading(true);
            let response = await withdrawlRequest(body);
            if (response.code === 201 || response.code === 200) {
                console.log(response)
                setIsLoading(false);
                setAccountNumber("")
                setAccountTitle("")
                setAmount("")
                setBankName("")
                setContact("")
                toast?.success(`${response?.message} your transaction id is ${response?.result?.transaction_uid}`);
                handleGetUser();
            } else if (response.code === 401) {
                toast?.error(response?.errors);
                setIsLoading(false);
            } else {
                // optional: show other errors
                // for (const [key, value] of Object.entries(response?.errors)) {
                //     toast?.error(value);
                // }
                setIsLoading(false);
                setAccountNumber("")
                setAccountTitle("")
                setAmount("")
                setBankName("")
                setContact("")
                setIsLoading(false);
            }
        }

    };


    const handleGetBankList = async () => {
        let response = await bankListRequest();
        if (response?.code === 200) {
            setBankList(response?.result?.bank_list?.original?.data)
        }
    }

    useEffect(() => {
        handleGetBankList();
    }, [])

    return (
        <div className="row">
            <div className="col-lg-12">
                <h3 className='fw-bold mb-0'>Request Withdrawal</h3>
                <p>
                    Request a withdrawal to your preferred payment method. Current balance: PKR {wallet_balance}
                </p>

                <Form className='row my-5' onSubmit={handleSubmit}>
                    <Form.Group className="col-lg-6 mb-3">
                        <Form.Label>Account Title</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter account title"
                            value={accountTitle}
                            onChange={handleAccTitle}
                        />
                    </Form.Group>

                    <Form.Group className="col-lg-6 mb-3">
                        <Form.Label>Amount</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder={`Maximum amount ${wallet_balance}`}
                            value={amount}
                            onChange={handleAmount}
                        />
                    </Form.Group>

                    <Form.Group className="col-lg-6 mb-3">
                        <Form.Label>Contact</Form.Label>
                        <Form.Control
                            type="number"
                            value={contact}
                            placeholder='Enter Conact Number'
                            onChange={handleContact}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3 col-lg-6">
                        <Form.Label>Account Number</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Enter your account number"
                            value={accountNumber}
                            onChange={handleAccNumber}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3 col-lg-6">
                        <Form.Label>Select Bank</Form.Label>
                        <Form.Select onChange={handleBankName} aria-label="Default select example">
                            <option disabled value="" selected>--Select Bank--</option>
                            {Array?.isArray(bankList) && bankList?.length > 0 ? (
                                bankList?.map((item, i) => {
                                    return (
                                        <>
                                            <option key={i} value={item?.name}>{item?.name}</option>
                                        </>
                                    )
                                })
                            ) : <>
                                <option>No bank found</option>

                            </>}
                        </Form.Select>

                        <div className='d-none d-flex mt-2'>
                            <Form.Check
                                type="radio"
                                label="Jazz Cash"
                                name="paymentMethod"
                                value="jazzCash"
                                id="jazzcash"
                                checked={bankName === "jazzCash"}
                                onChange={handleBankName}
                            />
                            <Form.Check
                                className='ms-3'
                                type="radio"
                                label="Easy Paisa"
                                name="paymentMethod"
                                value="easypaisa"
                                id="easypaisa"
                                checked={bankName === "easypaisa"}
                                onChange={handleBankName}
                            />
                        </div>
                    </Form.Group>

                    <div>
                        <Button variant="primary" type="submit">
                            {isLoading ? <Loader /> : "Request Withdrawal"}
                        </Button>
                    </div>
                </Form>
            </div>
        </div >
    );
};

export default RequestWithdrawal;
